<template>
  <div id="app">
    <!-- 顶部导航 -->
    
    <Menu v-if="$route.path != '/home'"></Menu>
    <!-- 内容模块 -->
    <div>
      <router-view/>
    </div>
    
    <!-- 底部 -->
    <div class="footer-box box_s">
      <div class="o_v footer">
        <div class="fl" style="margin:13px 104px 0 0;">
          <img src="./assets/img/icon_slogo_home.png" alt="" srcset="">
        </div>
        <!-- <ul class="fl">
          <li class="title">友情链接</li>
          <li><a target="_blank" href="https://www.lvshou.net">绿瘦官网</a></li>
          <li><a target="_blank" href="https://bxj.lvshou.com">绿瘦变形记官网</a></li>
          <li><a target="_blank" href="http://www.lvshoujiankang.com/">绿瘦减肥训练营官网</a></li>
          
          <li><a target="_blank" href="http://www.lsmxg.com/">美学馆官网</a></li> 
        </ul> -->
        <ul class="fl">
          <li class="title">关于我们</li>
          <li>订房咨询热线：+86-021-33238888</li>
          <li>地址：上海市闵行区七莘路1885号A区</li>
        </ul>
        <ul class="fr" style="letter-spacing: 1.4px;">
          <li>开启无限精彩</li>
          <li>畅游寰宇，尽在掌中</li>
          <li class="wechat-code box_s">
            <img src="./assets/img/room_qrcode.png" alt="" srcset="" width="70px">
            <!-- <img src="http://www.lvshouhotel.com/lvshouhotel/QRcode.png" alt="" srcset="" width="70px"> -->
            
          </li>
        </ul>
      </div>
    </div>
    <div class="bottom">
      <p class="ta_c">© 上海绿瘦酒店有限公司 保留所有权利  <a href="http://www.beian.miit.gov.cn/" target="_blank" id="beian">备案号：沪ICP备19033971号-1</a></p>
    </div>
    
    
  </div>
</template>
<script>
import { routes } from "./router";
import Menu from './components/common/menu'
export default {
  name:'App',
  data(){
    return{
      routes,

    }
  },
  components:{
    Menu
  },
  methods:{
    
    
  }
}
</script>

<style lang="less">
#beian{
  cursor: pointer;
  font-size: 12px;
  color: #B6B6B6;
  letter-spacing: 1px;
  line-height: 48px;
  text-align: center;
}
#app{
  height: 100%;
  min-width: 1244px;
}
.footer-box{
  background: #242424;
  padding: 60px 100px;
  overflow: hidden;
  height: 300px;
  .footer{
    width: 1200px;
    margin: 0 auto;
    .title{
      color: #FFFFFF;
    }
    .wechat-code{
      background: #fff;
      width: 80px;
      height: 80px;
      padding: 5px;
    }
  }
  ul{
    max-width: 1440px;
    color: #C5C5C5;
    padding-bottom: 22px;
    letter-spacing: 2px;
    li{
      margin: 10px 120px 0 0;
    }
    a{
      cursor: pointer;
      display: block;
      color: #C5C5C5!important;
    }
  }
  
}
.bottom{
  width: 100%;
  height:48px;
  opacity: 0.67;
  background: #000000;
  p{
    font-size: 12px;
    color: #B6B6B6;
    letter-spacing: 1px;
    line-height: 48px;
    text-align: center;
  }
  
}
</style>
